import { render, staticRenderFns } from "./mainButton.vue?vue&type=template&id=241cb38f&scoped=true&"
import script from "./mainButton.vue?vue&type=script&lang=js&"
export * from "./mainButton.vue?vue&type=script&lang=js&"
import style0 from "./mainButton.vue?vue&type=style&index=0&id=241cb38f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "241cb38f",
  null
  
)

export default component.exports